<template>
  <div>
    <div class="top_me" >
      <div class="link_me" @click="showModal">
          <img src="../../images/link_me.png" alt="">
          <div>服务咨询</div>
      </div>
      <div class="go_top" @click="backTop" v-show="top_show">
            <img src='../../images/go_top.png' alt="">
            <div>回到顶部</div>
      </div>
    </div>
    <v-modal :visible="visible" @onCloseModal="handleCloseModal"></v-modal>
  </div>
</template>

<script>
import vModal from '@/components/modal/index.vue'

export default {
components: {
    vModal,
},
//   props: {
//     visible: {
//       type: Boolean,
//       default: false
//     }
//   },
  data(){
      return{
        top_show: false,
        visible: false,
      }
  },
   mounted () {
  window.addEventListener('scroll', this.scrollToTop)
  
},
destroyed () {
  window.removeEventListener('scroll', this.scrollToTop)
},
   methods: {
    showModal () {
      this.visible = true
    },
    handleCloseModal (val) {
      this.visible = val
    },

scrollToTop () {
    const that = this
    let height = document.body.offsetHeight
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    that.scrollTop = scrollTop
    if (that.scrollTop > height) {
      that.top_show = true
    } else {
      that.top_show = false
    }
  },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
  backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
  },
 }
}
</script>

<style lang="scss" scoped>
.modal_link{
  height: 342px;
  text-align: center;
}
.modal_tel img{
    width: 40px;
    height: 40px;
    margin-top: 56px;
}
// .modal_title{
//   margin-top:13px;
//   font-size:18px;
//   font-weight: 500;
// }
.modal_txt{
  margin-top:34px;
  font-size:18px;
  font-weight:400;
   opacity:0.8;
   color:#62636C
}
.modal_tel_txt{
    margin-top:12px;
  font-size:18px;
  font-weight:400;
   opacity:0.8;
   color:#62636C
}
.modal_btn_txt{
  margin: 0px auto;
   margin-top:48px;
   background: #F87942;
   color:#FFFEFE;
   font-size: 16px;
   text-align: center;
   width: 400px;
   height: 40px;
   line-height: 40px;
   border-radius: 30px;
   cursor: pointer;

}
.top_me{
  position: fixed;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
}
.go_top, .link_me{
  cursor: pointer;
  width: 74px;
  height: 74px;
  box-shadow:0px 4px 18px 2px rgba(248,121,66,0.2);
  color:#fff;
  font-size: 12px;
  font-weight:500;
  text-align: center;
}  
.link_me{
 background: #FD8753;
 border-radius:8px 0px 0px 8px ;
 margin-bottom: 8px;
}
.link_me img, .go_top img{
  width: 32px;
  height: 32px;
  margin: 10px 22px 7px;
}
.go_top{
   background: #FF9B6F;
   border-radius:8px 0px 0px  8px;
   opacity:0.8;

}
</style>